<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('app', [
            'app_state'
        ])
    }
}
</script>

<template>
    <div class="flex-all-centered-col" style="width: 100vw; height: 100vh; padding: 20em; text-align: center;">
        <p style="font-size: 2vw;">
            {{ $t(`app_state.scheduled_maintenance_title`) }}
        </p>
        <br>
        <p style="font-size: 1.35vw;">
            {{ $t(`app_state.scheduled_maintenance_text`).replace('#S#', $formatDate(app_state.start_date)).replace('#E#', $formatDate(app_state.end_date)) }}
        </p>
        <p style="font-size: 1.25vw;">
            {{ $t(`app_state.thank`) }}
        </p>
    </div>
</template>

<style scoped lang="scss">

</style>